"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = useIsMobile;
const react_1 = require("react");
/**
 * Hook to detect if the viewport is mobile-sized.
 * Uses matchMedia for efficient updates on resize.
 *
 * @param breakpoint - The max-width breakpoint in pixels (default: 767)
 * @returns Whether the viewport is currently mobile-sized
 *
 * @example
 * ```tsx
 * function ResponsiveComponent() {
 *   const isMobile = useIsMobile();
 *   return isMobile ? <MobileView /> : <DesktopView />;
 * }
 *
 * // With custom breakpoint
 * const isTablet = useIsMobile(1024);
 * ```
 */
function useIsMobile(breakpoint = 767) {
    const [isMobile, setIsMobile] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        // Check if window is available (client-side)
        if (typeof window === 'undefined')
            return;
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        setIsMobile(mediaQuery.matches);
        const handleResize = (e) => {
            setIsMobile(e.matches);
        };
        mediaQuery.addEventListener('change', handleResize);
        return () => {
            mediaQuery.removeEventListener('change', handleResize);
        };
    }, [breakpoint]);
    return isMobile;
}
